import { Cookies } from 'react-cookie';

import { LocationsOnMapResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const deleteLocationOnMap = async (slug: string, locationId: number) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.delete(`v1/floor-plans/${slug}/locations/${locationId}/`, {
    headers: {
      Authorization: token,
    },
  });
  return data.data as LocationsOnMapResponse;
};
